var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C2.46245 0 0 2.46245 0 5.5C0 8.53772 2.46245 11 5.5 11C8.53772 11 11 8.53772 11 5.5C11 2.46245 8.53772 0 5.5 0ZM5.5 10.3233C2.84642 10.3233 0.6875 8.15358 0.6875 5.49998C0.6875 2.8464 2.84642 0.687479 5.5 0.687479C8.15358 0.687479 10.3125 2.84641 10.3125 5.49998C10.3125 8.15355 8.15358 10.3233 5.5 10.3233ZM7.69502 3.48752L4.46805 6.73475L3.01485 5.28155C2.88061 5.14731 2.66302 5.14731 2.52861 5.28155C2.39438 5.41578 2.39438 5.63337 2.52861 5.76761L4.23 7.46917C4.36424 7.60323 4.58183 7.60323 4.71624 7.46917C4.73171 7.4537 4.74495 7.43685 4.75698 7.41933L8.18142 3.97374C8.31549 3.8395 8.31549 3.62191 8.18142 3.48752C8.04702 3.35328 7.82942 3.35328 7.69502 3.48752Z",
    fill: "#02AFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/marker-icon.04f6e09acc7234380c919352f0b5bab7.svg";
export { ForwardRef as ReactComponent };